import Vue from 'vue'
import VueRouter from 'vue-router'
import Instrument from '../views/Instrument'
import Game from '../views/game'
import Article from '../views/article'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/article'
  },
  {
    path: '/instrument', /* 工具 */
    name: 'instrument',
    component: Instrument
  },
  {
    path: '/game', /* 游戏 */
    name: 'game',
    component: Game
  },
  {
    path: '/article', /* 文章 */
    name: 'article',
    component: Article
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
